import { createOperationClient } from "@/services/react-query.service/graphql-client";
import { queryKeys } from "@/services/react-query.service/query-keys";
import { useQuery } from "@tanstack/react-query";

import { DataRequestEntity } from "../../models/data-request.model";

import { dataRequestEntityDetailQuery } from "./data-request.gql";

interface DataRequestEntityDetailResponse {
  dataRequestEntity: DataRequestEntity;
}

export interface UseGetDataRequestEntityProps {
  id?: string;
  enabled?: boolean;
}

export const useGetDataRequestEntityQuery = ({ id, enabled = true }: UseGetDataRequestEntityProps) => {
  const queryResult = useQuery({
    queryKey: queryKeys.dataRequests.entity(id ?? ""),
    queryFn: async () => {
      if (!id) {
        throw new Error("Data Request Entity ID is required");
      }

      const client = createOperationClient("DataRequestEntityDetail");
      const data = await client.request<DataRequestEntityDetailResponse>(dataRequestEntityDetailQuery, {
        id,
      });

      return data.dataRequestEntity;
    },
    enabled: enabled && !!id,
    staleTime: 5 * 60 * 1000,
  });

  return {
    queryResult,
    loading: queryResult.isLoading,
    error: queryResult.error,
    dataRequestEntity: queryResult.data ?? null,
  };
};
